import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { BASE_URL } from "../../global";

const submitbtn = {
    width: "100%",
    height: "52px",
    fontSize: "16px",
};

const Paypal = ({ business, amount, currencyCode = "USD", subKey }) => {
    const formRef = useRef(null);

    const custom = {
        type: 1,
        payer_user_key: sessionStorage.getItem("pk_user_key"),
        sub_key: subKey,
    };

    const jsonCustom = JSON.stringify(custom);

    const handleProceed = (e) => {
        if (!amount) {
            toast.warning("Please select a plan.", {
                autoClose: 3000,
            });
            return;
        }
        if (!business) {
            toast.warning("Invalid admin business ID.", {
                autoClose: 3000,
            });
            return;
        }

        // Submit the form programmatically
        if (formRef.current) {
            formRef.current.submit();
        }
    };
    return (
        <form ref={formRef} action="https://www.sandbox.paypal.com/cgi-bin/webscr" method="post" target="_top">
            <input type="hidden" name="cmd" value="_xclick" />
            <input type="hidden" name="business" value={business} />
            <input type="hidden" name="currency_code" value={currencyCode} />
            <input type="hidden" name="amount" value={amount} />
            <input type="hidden" name="item_name" value="Subscription Payment" />
            {/* <input type="hidden" name="item_number" value={sessionStorage.getItem("pk_user_key")} /> */}
            <input type="hidden" name="return" value={BASE_URL + "dashboard"} />
            <input type="hidden" name="cancel_return" value={BASE_URL + "dashboard"} />
            {/* <input type="hidden" name="return" value={"http://localhost:3000/2024/paperboy/" + "dashboard"} />
            <input type="hidden" name="cancel_return" value={"http://localhost:3000/2024/paperboy/" + "dashboard"} /> */}
            <input type="hidden" name="notify_url" value={BASE_URL + "API/pay_notify.php"} />
            {/* <input type="hidden" name="image_url" value={BASE_URL + "API/logo.png"} /> */}
            <input type="hidden" name="image_url" value={BASE_URL + "API/paperboy_paypal_logo.png"} />
            {/* <input type="hidden" name="custom" value={subKey} /> */}
            <input type="hidden" name="custom" value={jsonCustom} />
            {/* <button type="submit">Pay</button> */}

            <button
                type="button"
                onClick={handleProceed}
                style={submitbtn}
                className="btn btn-dark text-white d-flex align-items-center justify-content-center fw-semibold"
            >
                Proceed
            </button>
        </form>
    );
};

export default Paypal;
